import CommonWidget from './Common/Common.Widget';
import LevelWaterWidget from './LevelWater/LevelWater';
import RainWidgets from './Rain/Rain.Widgets';
import TemperatureWidget from './Temperature/Temperature.Widget';
import WindWidget from './Wind/Wind.Widget';

export const Widgets = {
  Rain: RainWidgets,
  Temperature: TemperatureWidget,
  Wind: WindWidget,
  LevelWater: LevelWaterWidget,
  Common: CommonWidget,
};
